import { styled } from '@nykaa/ui-components';
import { resetButton } from 'shared/styles/mixin';

export const FaqWrapper = styled.div`
  margin-top: 40px;
  padding: 0 ${({ theme }) => theme.spacing.spacing200} 32px;
`;

export const Heading = styled.h1`
  ${({ theme }) => theme.typography.subTitleLarge};
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const FaqItem = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.textSecondary};
  padding: ${({ theme }) => theme.spacing.spacing80} 0;
`;

export const FaqQuestion = styled.button`
  ${resetButton}

  ${({ theme }) => theme.typography.bodyMedium};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-align: left;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const FaqAnswer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: 1.5;

  p {
    margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  }

  ol {
    padding-left: ${({ theme }) => theme.spacing.spacing80};

    li {
      margin-bottom: ${({ theme }) => theme.spacing.spacing40};
    }
  }
`;

export const Arrow = styled.img<{ expanded: boolean }>`
  width: 12px;
  height: 7px;
  transition: transform 0.3s ease;
  transform: rotate(${(props) => (props.expanded ? '180deg' : '0deg')});
`;

export const ViewMoreButton = styled.button`
  ${resetButton}

  ${({ theme }) => theme.typography.bodyMedium};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.spacing40};
  padding: ${({ theme }) => theme.spacing.spacing80} 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textPrimary};
`;
